import { PrismicText } from "@prismicio/react";
import moment from "moment";
import React from "react";

interface CardProps {
    data: any;
}

const RelatedCard: React.FC<CardProps> = ({ data }) => {
    return (
        <div className="flex flex-col bg-white rounded-lg h-full w-full overflow-clip">
            <div className="relative">
                <img src={data?.imageSrc} alt={data.title} className="w-full h-48" />
                <div className="absolute bottom-4 left-4">
                    <div className="top-0 right-0 bg-red text-white text-xs px-4 py-2 rounded font-normal">
                        <PrismicText field={data?.subject} />
                    </div>
                </div>
            </div>

            <div className="p-4">
                <h3 className="text-lg font-gambetta font-bold"><PrismicText field={data?.title} /></h3>
                <p className="text-gray-600 text-sm"><PrismicText field={data?.description} /></p>
                <a
                    href={data?.link}
                    className="text-red text-sm font-normal mt-3 inline-flex items-center hover:font-semibold"
                >
                    Read More <span className="ml-1">→</span>
                </a>
            </div>
        </div>
    );
};

export default RelatedCard;
